// This file includes polyfills needed by Angular and is loaded before the app.
// You can add your own extra polyfills to this file.
//
// Learn more in https://angular.io/guide/browser-support

// IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/es6/array';
import 'core-js/es6/date';
import 'core-js/es6/function';
import 'core-js/es6/map';
import 'core-js/es6/math';
import 'core-js/es6/number';
import 'core-js/es6/object';
import 'core-js/es6/parse-float';
import 'core-js/es6/parse-int';
import 'core-js/es6/regexp';
import 'core-js/es6/set';
import 'core-js/es6/string';
import 'core-js/es6/symbol';
import 'core-js/es6/weak-map';


// If the application will be indexed by Google Search, the following is required.
// Google bot uses a renderer based on Chrome 41.
// https://developers.google.com/search/docs/guides/rendering
import 'core-js/es7/array';

// IE10 and IE11 requires the following for NgClass support on SVG elements
import 'classlist.js';

// IE10 and IE11 requires the following for the Reflect API.
import 'core-js/es6/reflect';

// Evergreen browsers require these.
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
import 'core-js/es7/reflect';


// Web Animations `@angular/platform-browser/animations`
// Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
// Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
import 'web-animations-js'; // Run `npm install --save web-animations-js`.

// By default, zone.js will patch all possible macroTask and DomEvents
// user can disable parts of macroTask/DomEvents patch by setting following flags
// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

// in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
// with the following flag, it will bypass `zone.js` patch for IE/Edge
// (window as any).__Zone_enable_cross_context_check = true;

// Zone JS is required by default for Angular itself.
import 'zone.js'; // Included with Angular CLI.

// Add global to window, assigning the value of window itself.
(window as any).global = window;
(window as any).process = {
  env: { DEBUG: undefined }
};

// fix for ngx-chart to work on IE11
if (typeof SVGElement.prototype.contains === 'undefined') {
  SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}

// polyfill for Element.matches
// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype['matchesSelector'] ||
    Element.prototype['mozMatchesSelector'] ||
    Element.prototype['msMatchesSelector'] ||
    Element.prototype['oMatchesSelector'] ||
    function (selector: string): boolean {
      const matches = (this.document || this.ownerDocument).querySelectorAll(selector);
      let i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
}

function emitEvent(eventName: string, detail?: any): void {
  window.dispatchEvent(new CustomEvent(eventName, {
    detail
  }));
}

Object.assign(window, { emitEvent });


declare global {
  interface Window {
    emitEvent(eventName: string, detail?: any): void;
  }
}
